<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Formações</h2>
  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-12">
      <!-- timeline wrapper -->
      <div class="timeline edu rounded bg-white shadow-dark padding-30 overflow-hidden">

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">2020 - 2024</span>
            <h3 class="title">Bacharelado em Sistemas de Informação</h3>
            <p><strong>Estácio de Sá</strong> – Florianópolis, SC</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">2017 - 2019</span>
            <h3 class="title">Técnico em Informática Integrado ao Ensino Médio</h3>
            <p><strong>CONECTE (SENAI/CTAI)</strong> – Florianópolis, SC</p>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>
  </div>
</div>